export const BUTTON_THEME_BLACK = "black";
export const BUTTON_THEME_WHITE = "white";
export const BUTTON_THEME_BLUE_LARGE = "blueLarge";
export const BUTTON_THEME_BLUE_MEDIUM = "blueMedium";
export const BUTTON_THEME_BLACK_SMALL = "blackSmall";
export const BUTTON_THEME_WHITE_LIGHT_FOCUS = "whiteLightFocus";
export const LINK_BUTTON_THEME_BLUE_MEDIUM = "blueMediumLink";
